// Berachain API utility for fetching vault data

const BERACHAIN_API_URL = "https://api.berachain.com/";

interface RewardVaultResponse {
  data: {
    rewardVault: {
      dynamicData: {
        apr: string; // APR is returned as a string
        tvl: string; // TVL is returned as a string
      };
    };
  };
}

export async function fetchRewardVaultData(
  vaultAddress: string,
): Promise<RewardVaultResponse | null> {
  // Simplified query for just APR and TVL
  const query = `
    query GetRewardVault($vaultId: String!, $chain: GqlChain!) {
      rewardVault: polGetRewardVault(vaultAddress: $vaultId, chain: $chain) {
        dynamicData {
          apr
          tvl
        }
      }
    }
  `;

  const variables = {
    vaultId: vaultAddress,
    chain: "BERACHAIN",
  };

  try {
    const response = await fetch(BERACHAIN_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        operationName: "GetRewardVault",
        variables,
        query,
      }),
    });

    if (!response.ok) {
      return null;
    }

    const data: RewardVaultResponse = await response.json();
    return data;
  } catch (_error) {
    return null;
  }
}

// Helper function to extract APR from the response (returns percentage)
export function extractAPR(data: RewardVaultResponse | null): number {
  if (!data?.data?.rewardVault?.dynamicData?.apr) {
    return 0;
  }
  // Parse the string APR value to a number and multiply by 100 for percentage
  const apr = parseFloat(data.data.rewardVault.dynamicData.apr) * 100;
  return Number.isNaN(apr) ? 0 : apr;
}

// Helper function to extract TVL from the response
export function extractTVL(data: RewardVaultResponse | null): number {
  if (!data?.data?.rewardVault?.dynamicData?.tvl) {
    return 0;
  }
  // Parse the string TVL value to a number
  const tvl = parseFloat(data.data.rewardVault.dynamicData.tvl);
  return Number.isNaN(tvl) ? 0 : tvl;
}
